import { branding, Colour_Tournament } from "./Utils";

const names = [
  {
    id: "attacking_kicks",
    name: "Attacking kicks",
  },
  {
    id: "av_gain",
    name: "Average gain",
  },
  {
    id: "carries",
    name: "Carries",
  },
  {
    id: "clean_break",
    name: "Linebreaks",
  },
  {
    id: "drop_goals",
    name: "",
  },
  {
    id: "errors",
    name: "Errors",
  },
  {
    id: "forty_twenty",
    name: "40/20s",
  },
  {
    id: "game_id",
    name: "",
  },
  {
    id: "goals",
    name: "",
  },
  {
    id: "kicks_in_gen_play",
    name: "Kicks in general play",
  },
  {
    id: "marker_tackles",
    name: "Marker tackles",
  },
  {
    id: "metres",
    name: "Metres",
    metres: true,
  },
  {
    id: "missed_goals",
    name: "",
  },
  {
    id: "missed_tackles",
    name: "Missed tackles",
  },
  {
    id: "offload",
    name: "Offloads",
  },
  {
    id: "penalties",
    name: "Penalties conceded",
  },
  {
    id: "player_id",
    name: "",
  },
  {
    id: "red_card",
    name: "",
  },
  {
    id: "run_from_dummy_half",
    name: "Runs from dummy half",
  },
  {
    id: "tackle_busts",
    name: "Tackle busts",
  },
  {
    id: "tackles",
    name: "Tackles",
  },
  {
    id: "team_id",
    name: "",
  },
  {
    id: "tries",
    name: "Tries",
  },
  {
    id: "try_assists",
    name: "Try assists",
  },
  {
    id: "yellow_card",
    name: "Yellow cards",
  },
  {
    id: "break_assist",
    name: "Linebreak assists",
  },
  {
    id: "conversions",
    name: "",
  },
  {
    id: "dummy_half_metres",
    name: "Dummy half metres",
    metres: true,
  },
  {
    id: "hit_up_metres",
    name: "Hit up metres",
    metres: true,
  },
  {
    id: "hit_ups",
    name: "Hit ups",
  },
  {
    id: "kick_from_hand_metres",
    name: "Kick from hand metres",
    metres: true,
  },
  {
    id: "kick_return_metres",
    name: "Kick return metres",
    metres: true,
  },
  {
    id: "kick_returns",
    name: "Kick returns",
  },
  {
    id: "minutes_player_total",
    name: "",
  },
  {
    id: "missed_conversions",
    name: "",
  },
  {
    id: "missed_penalty_goals",
    name: "",
  },
  {
    id: "passes",
    name: "Passes",
  },
  {
    id: "penalty_goals",
    name: "",
  },
  {
    id: "twenty_forty",
    name: "20/40s",
  },
  {
    id: "ruck_infringements",
    name: "Ruck infringements",
  },
  {
    id: "set_restart_conceded_10m_offside",
    name: "Six agains conceded (10m offside)",
    line_2: "(10m offside)",
  },
  {
    id: "set_restart_won",
    name: "Six agains won",
  },
  {
    id: "kick_defused",
    name: "Kicks defused",
  },
  {
    id: "kick_not_defused",
    name: "Kicks not defused",
  },
  {
    id: "ball_run_metres",
    name: "Carry metres",
    metres: true,
  },
  {
    id: "post_contact_metres",
    name: "Post contact metres",
    metres: true,
  },
  {
    id: "one_on_one_steal",
    name: "One-on-one steal",
  },
  {
    id: "one_point_field_goal",
    name: "",
  },
  {
    id: "two_point_field_goal",
    name: "",
  },
  {
    id: "tackle_efficiency",
    name: "Tackle success",
    percent: true,
  },
  {
    id: "goal_line_dropout",
    name: "Goal line dropouts",
  },
  {
    id: "possession",
    name: "Possession",
    percent: true,
  },
  {
    id: "missed_field_goals",
    name: "",
  },
  {
    id: "ptb_opp_20m",
    name: "PTBs in opp. 20",
  },
  {
    id: "set_handover",
    name: "Set handovers",
  },
  {
    id: "kick_receipt",
    name: "Kick receipts",
  },
  {
    id: "scrum_won",
    name: "Scrums won",
  },
  {
    id: "scrum_lost",
    name: "Scrums lost",
  },
  {
    id: "on_report",
    name: "",
  },
  {
    id: "complete_sets",
    name: "Sets completed",
  },
  {
    id: "completionPercentage",
    name: "Completion rate",
    percent: true,
  },
  {
    id: "incomplete_sets",
    name: "Incomplete sets",
  },
  {
    id: "play_the_ball",
    name: "PTBs",
  },
];

export class CustomMatchStats {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "CustomMatchStats";
    this.scene = "CustomMatchStats";
    this.data = [];
    this.page = 7053;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      if (options.push_up) {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "1";
      } else {
        xml.payload.field.find((item) => {
          return item.attr.name === "0000";
        }).value = "0";
      }

      xml.payload.field.find((item) => {
        return item.attr.name === "0000104";
      }).value = "Match Stats";

      xml.payload.field.find((item) => {
        return item.attr.name === "0004";
      }).value = options?.stats?.length;

      xml.payload.field.find((item) => {
        return item.attr.name === "006";
      }).value = options?.game?.home_team?.variables?.badge || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "007";
      }).value = options?.game?.away_team?.variables?.badge || "";

      for (let x = 0; x < options?.stats?.length; x++) {
        let stat = options?.stats?.[x];
        let home_value, away_value;
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (x + 1) + "01";
        }).value = names?.find((s) => s?.id === stat)?.name ?? stat ?? "";
        if (stat === "Pre-match win predictor") {
          home_value =
            (Math.floor(
              parseFloat(
                options.game?.win_predictor?.prematchProbabilities?.home_win
              ) * 100
            ) || 0) + "%";
          away_value =
            (Math.floor(
              parseFloat(
                options.game?.win_predictor?.prematchProbabilities?.away_win
              ) * 100
            ) || 0) + "%";
        } else if (stat === "Live win predictor") {
          home_value =
            (Math.floor(
              parseFloat(
                options.game?.win_predictor?.currentProbabilities?.home_win
              ) * 100
            ) || 0) + "%";
          away_value =
            (Math.floor(
              parseFloat(
                options.game?.win_predictor?.currentProbabilities?.away_win
              ) * 100
            ) || 0) + "%";
        } else {
          home_value = options?.game?.opta_home_team_stats?.[stat] || 0;
          away_value = options?.game?.opta_away_team_stats?.[stat] || 0;
          if (stat === "completionPercentage") {
            home_value = Math.round(home_value);
            away_value = Math.round(away_value);
          }
          if (stat === "tackle_efficiency") {
            home_value = Math.round(home_value);
            away_value = Math.round(away_value);
          }
          if (stat === "complete_sets") {
            home_value =
              home_value +
              "/" +
              (parseInt(home_value) +
                parseInt(
                  options.game?.opta_home_team_stats?.["incomplete_sets"] || 0
                ));
            away_value =
              away_value +
              "/" +
              (parseInt(away_value) +
                parseInt(
                  options.game?.opta_away_team_stats?.["incomplete_sets"] || 0
                ));
          }
          home_value += names?.find((s) => s?.id === stat)?.percent ? "%" : "";
          away_value += names?.find((s) => s?.id === stat)?.percent ? "%" : "";
          home_value += names?.find((s) => s?.id === stat)?.metres ? "m" : "";
          away_value += names?.find((s) => s?.id === stat)?.metres ? "m" : "";
        }
        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (x + 1) + "02";
        }).value = home_value;

        xml.payload.field.find((item) => {
          return item.attr.name === "0" + (x + 1) + "03";
        }).value = away_value;
      }

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
